// fontFamily = 'oswald', fontSize = '13', fontWeight, children;
type AppButtonProps = {
  children: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
  fontFamily?: 'oswald' | 'lato';
  fontWeight?: '400' | '500' | '600' | '700';
  fontSize?: '13' | '14' | '15' | '16' | '17' | '18' | '19' | '20' | '21' | '22' | '23' | '24';
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'transparent';
  className?: string;
  disabled?: boolean;
  dataTestId?: string;
  args?: any;
};

export const AppButton = ({
  children,
  variant = 'primary',
  type = 'button',
  onClick = () => {},
  fontFamily = 'oswald',
  fontSize = '13',
  fontWeight = '500',
  disabled = false,
  className = '',
  dataTestId = '',
  ...args
}: AppButtonProps) => {
  return (
    <button
      type={type}
      className={`btn btn-${variant} font-${fontFamily} font-${fontSize} font-${fontWeight} text-uppercase  ${
        disabled && 'disabled cursor-not-allowed'
      } ${className}`}
      onClick={() => onClick()}
      disabled={disabled}
      data-test={dataTestId || 'testing-button'}
      data-testid={dataTestId || 'testing-button'}
      {...args}
    >
      {children}
    </button>
  );
};

export default AppButton;
